export default "__VITE_ASSET__BcuarlL4__"